import { alkymetricsClient } from '../alkymetricsClient';

export const getCountries = async () => {
  const { data } = await alkymetricsClient.get('/country');
  return data;
};
